import CallButton from "components/CallButton";

/**
 * Error View
 */
export default function ErrorView() {
  return (
    <div className="mx-auto max-w-lg px-4 py-16 text-center">
      <h1 className="mb-4 font-serif text-3xl text-soil">
        Something went wrong
      </h1>
      <p className="mb-8 text-lg text-soil/70">
        We're having trouble loading your quote. Please try again or contact us
        for assistance.
      </p>
      <CallButton variant="inline" />
    </div>
  );
}
